module.exports = __webpack_public_path__ + "media/images/emblems/Dorenaz-0bb85d09b37b2785f6d909851f72f705.png";